import { Controller } from "@hotwired/stimulus";
// @ts-expect-error: this is untyped https://github.com/mmccall10/el-transition/issues/11
import { enter, leave } from "el-transition";

export default class AnimatableController extends Controller {
  static values = {
    autoHide: {
      default: false,
      type: Boolean,
    },
  };

  declare autoHideValue: boolean;

  async enter(): Promise<void> {
    if (this.autoHideValue) {
      this.element.classList.remove("hidden");
    }

    await enter(this.element);
  }

  async leave(): Promise<void> {
    await leave(this.element);

    if (this.autoHideValue) {
      this.element.classList.add("hidden");
    }
  }
}
